// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import { Element } from '@fulcrumapp/fulcrum-core';
import { InfoAltIcon } from '../../../icons';
import Dialog from '../../../shared/dialog';

export default class ElementDescriptionButton extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    element: PropTypes.instanceOf(Element).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      showDescription: false,
    };
  }

  render() {
    const { styles } = ElementDescriptionButton;

    const classes = css(styles.container,
      !this.props.element.description && styles.hidden);

    return (
      <div
        className={cx(this.props.className, classes)}
        title={this.props.element.description}
        onClick={this.handleButtonClick}
      >
        <InfoAltIcon className={css(styles.icon)} />
        <Dialog
          negative={null}
          show={this.state.showDescription}
          title={this.props.element.label}
          onPositiveClick={this.handleAlertPositiveClick}
        >
          <div>{this.props.element.description}</div>
        </Dialog>
      </div>
    );
  }

  handleButtonClick = (event) => {
    this.setState({ showDescription: true });
  };

  handleAlertPositiveClick = (event) => {
    this.setState({ showDescription: false });
  };
}

const styles = cssInJS({
  container: {
    visibility: 'visible',
    width: '3%',
    color: '#aaa',
    paddingTop: 10,
    fill: '#ccc',
    cursor: 'pointer',
    backgroundColor: '#fff',

    ':hover': {
      fill: '#444',
    },

    '@phone': {
      display: 'block',
      position: 'absolute',
      right: 32,
      top: 0,
      width: 16,
      height: 16,
      zIndex: 10,
    },
  },

  hidden: {
    display: 'none',
  },

  icon: {
    display: 'inline-block',
    width: 16,
    height: 16,
  },
});

ElementDescriptionButton.styles = styles;
